import styled from 'styled-components';

export const CanvasWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background: #1a1a1a;
  position: relative;
  overflow: visible;
`;

export const Canvas = styled.div`
  position: relative;
  width: 1920px;
  height: 1080px;
  background: #000;
  margin: auto;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  flex-shrink: 0;
`;

export const GridOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 10px 10px;
  pointer-events: none;
  z-index: 1;
`;

export const ComponentWrapper = styled.div`
  position: absolute;
  background: rgba(30, 30, 30, 0.9);
  border: 2px solid #444;
  border-radius: 8px;
  color: white;
  cursor: move;
  transition: opacity 0.3s ease;
  
  &:hover {
    border-color: #666;
  }
`;

export const DragHandle = styled.div`
  width: 20px;
  height: 20px;
  cursor: move;
  opacity: 0.6;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 1;
  }
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
  }
  
  &::before {
    top: 4px;
    left: 4px;
    width: 12px;
    height: 2px;
    box-shadow: 0 4px 0 rgba(255, 255, 255, 0.8), 0 8px 0 rgba(255, 255, 255, 0.8);
  }
  
  &::after {
    top: 4px;
    left: 4px;
    width: 2px;
    height: 12px;
    box-shadow: 4px 0 0 rgba(255, 255, 255, 0.8), 8px 0 0 rgba(255, 255, 255, 0.8);
  }
`;

export const RemoveButton = styled.button`
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  color: #ff4444;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 1;
  }
`;


export const CanvasContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
`;


export const ResizeHandle = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: se-resize;
  
  &::after {
    content: '';
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 5px;
    height: 5px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
  }
  
  &::before {
    content: '';
    position: absolute;
    right: 8px;
    bottom: 3px;
    width: 5px;
    height: 5px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
  }
`;